import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { v4 as uuidV4 } from 'uuid';
import notificationConstants from '../constants/notificationConstants';
const defaultSettings = {
  // show close button unless overridden in notification
  showCloseButton: true,
  // by default, close notifications after 5s unless otherwise specified
  autoClose: 5000
};

// must run function fresh every time to get a new uuid
const defaultContent = () => ({
  // id comes in before options so passed in IDs take precedent
  id: uuidV4().toUpperCase()
});
const addBlockingNotification = function addBlockingNotification(content) {
  let settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    content,
    settings,
    type: notificationConstants.CREATE_MODAL
  };
};
const addNotification = function addNotification(content) {
  let settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    content,
    settings,
    type: notificationConstants.CREATE
  };
};
const block = (content, settings) => addBlockingNotification(_objectSpread(_objectSpread({}, defaultContent()), content), _objectSpread(_objectSpread({}, defaultSettings), settings));
const dismiss = id => {
  if (id !== undefined) {
    return {
      id,
      type: notificationConstants.DISMISS
    };
  }
  return {
    type: notificationConstants.DISMISS
  };
};
const error = function error(content) {
  let settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return addNotification(_objectSpread(_objectSpread(_objectSpread({}, defaultContent()), {}, {
    // goes first in case things like id are passed in with content
    headerMessage: 'Error'
  }, content), {}, {
    messageType: 'error'
  }), _objectSpread(_objectSpread({}, defaultSettings), settings));
};
const info = function info(content) {
  let settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return addNotification(_objectSpread(_objectSpread(_objectSpread({}, defaultContent()), content), {}, {
    messageType: 'info'
  }), _objectSpread(_objectSpread({}, defaultSettings), settings));
};
const save = function save(content) {
  let settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return addNotification(_objectSpread(_objectSpread(_objectSpread({}, defaultContent()), content), {}, {
    id: notificationConstants.UNSAVED_CHANGES_WARNING,
    messageType: 'save'
  }), _objectSpread(_objectSpread({}, defaultSettings), settings));
};
const success = function success(content) {
  let settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return addNotification(_objectSpread(_objectSpread(_objectSpread({}, defaultContent()), {}, {
    // goes first in case things like id are passed in with content
    headerMessage: 'Success'
  }, content), {}, {
    messageType: 'success'
  }), _objectSpread(_objectSpread({}, defaultSettings), settings));
};
const upload = function upload(content) {
  let settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return addNotification(_objectSpread(_objectSpread(_objectSpread({}, defaultContent()), content), {}, {
    messageType: 'upload'
  }), _objectSpread(_objectSpread({}, defaultSettings), {}, {
    // show the notifications longer if there were any failures or if there are lots of files
    autoClose: content.failedToUpload && content.failedToUpload.length || content.files.length + content.failedToUpload.length > 22 ? 25000 : 10000
  }, settings));
};
const validationError = function validationError(content) {
  let settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return addNotification(_objectSpread(_objectSpread(_objectSpread({}, defaultContent()), {}, {
    // goes first in case things like id are passed in with content
    headerMessage: 'Validation Error'
  }, content), {}, {
    messageType: 'error'
  }), _objectSpread(_objectSpread({}, defaultSettings), settings));
};
const actions = {
  block,
  dismiss,
  error,
  info,
  save,
  success,
  upload,
  validationError
};
export default actions;